import { ErrorManagement } from '@printdeal/error-management/react';
import Api from '../Api';
import {
  type ProductAdvisorRequest,
  type ProductAdvisorResponse,
} from './ProductAdvisor.types';
import { parseProductAdvisorResponse } from './ProductAdvisorResponseParser';

class ProductAdvisorService extends Api {
  async getProductAdvisor(
    request: ProductAdvisorRequest,
    signal?: AbortSignal,
  ): Promise<ProductAdvisorResponse> {
    if (!this.httpClient.defaults.baseURL) {
      const error = new Error('GATSBY_PRODUCT_AI_ENDPOINT is not configured');

      ErrorManagement.exception({
        exception: error,
        tags: { fileLocation: 'ProductAdvisorService' },
        fingerprint: ['quote-product-advisor-missing-endpoint'],
      });

      throw error;
    }

    let responseData: unknown;

    try {
      const response = await this.httpClient.post<unknown>('/product-advisor', request, { signal });
      responseData = response.data;
    } catch (error) {
      if (signal?.aborted) {
        throw error;
      }

      const requestError = error instanceof Error
        ? error
        : new Error('Product advisor request failed');

      ErrorManagement.exception({
        exception: requestError,
        tags: { fileLocation: 'ProductAdvisorService' },
        fingerprint: ['quote-product-advisor-request-error'],
      });

      throw requestError;
    }

    const parsedResponse = parseProductAdvisorResponse(responseData);

    if (!parsedResponse) {
      const error = new Error('Invalid product advisor API response');

      ErrorManagement.exception({
        exception: error,
        tags: { fileLocation: 'ProductAdvisorService' },
        fingerprint: ['quote-product-advisor-invalid-response'],
      });

      throw error;
    }

    return parsedResponse;
  }
}

export default ProductAdvisorService;
